module.exports = __webpack_public_path__ + "img/logo.d74032a9.png";